import React from "react";
import Picky from "ikizmet-react-picky";
import "ikizmet-react-picky/dist/picky.css"; // Include CSS
import PropTypes from "prop-types";

// Local version for testing changes
// import Picky from '../../../../../github/react-picky/dist/'
// import '../../../../../github/react-picky/dist/picky.css'

class multiSelectDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
      arrayValue: []
    };
    this.selectOption = this.selectOption.bind(this);
    this.selectMultipleOption = this.selectMultipleOption.bind(this);
  }

  componentDidMount() {
    if (this.props.selectAll) {
      this.setState({ arrayValue: this.props.options });
    }
    if (this.props.enableDefaultSelected) {
      if (this.props.defaultSelected) {
        const newArray = this.props.options.slice(0, this.props.defaultSelectedNumber);
        // console.log(newArray)
        this.setState({ arrayValue: newArray });
      }
      if (!this.props.defaultSelected) {
        // console.log('dont use defaults, use state selected!', this.props.selectedFilters)
        this.setState({
          arrayValue: this.props.selectedFilters,
          value: this.props.selectedFilters
        });
      }
    }
    if (this.props.displayCheckedOnly) {
      this.setState({ arrayValue: this.props.selectedFilters, value: this.props.options });
    }
  }

  componentDidUpdate() {
    if (this.props.selectedFilters !== undefined) {
      if (this.props.selectedFilters !== this.state.arrayValue) {
        this.setState({ arrayValue: this.props.selectedFilters });
      }
    }
  }

  selectOption(value) {
    // console.log('Vals', value)
    this.setState({ value });
  }

  selectMultipleOption(value) {
    if (this.props.haveOnSelectChange) {
      this.props.onSelectChange(value);
    }
    if (value.length === 0) {
      return;
    }
    if (this.props.enableMax) {
      const picky = document.getElementsByClassName("picky__dropdown");

      if (this.props.singlePicker) {
        //console.log("Val", value, value.length, this.props.maxSelect, value.length === 2, value[0] !== value[1]);
        if (value.length === 2 && value[0] !== value[1]) {
          //console.log("have 2, display new");
          picky[0].classList.remove("max-selected");
          this.props.maxSelected(false);
          this.setState({ arrayValue: [value[1]] });
          // } else if (value.length === undefined) {
          //   picky[0].classList.remove('max-selected')
          //   this.props.maxSelected(false)
          //   this.setState({ arrayValue: [value] })
        } else {
          this.setState({ arrayValue: value });
        }
      } else {
        if (value.length === this.props.maxSelect) {
          picky[0].classList.add("max-selected");
          this.props.maxSelected(true);
        }
        if (value.length > this.props.maxSelect && this.props.avoidSelectIfMaxSelected) {
          return;
        }
        if (value.length < this.props.maxSelect) {
          picky[0].classList.remove("max-selected");
          this.props.maxSelected(false);
        }
        if (value.length <= this.props.maxSelect) {
          this.setState({ arrayValue: value });
        }
      }
    } else {
      this.setState({ arrayValue: value });
    }
    if (this.props.filterType === "FilterLevel") {
      this.props.updateFilterLevel(value);
      this.props.updateFilters(value);
    }
    if (this.props.filterType === "FilterLevelLast") {
      this.props.updateFilterLevel(value);
    }
    if (this.props.filterType === "Region") {
      this.props.updateRegions(value);
      this.props.updateFilters(value);
    }
    if (this.props.filterType === "Sites") {
      this.props.updateSites(value);
      this.props.updateFilters(value);
    }
    if (this.props.filterType === "Locations") {
      this.props.updateLocations(value);
    }
    if (this.props.filterType === "Custom Range") {
      this.props.updateLocations(value);
      this.setState({ arrayValue: value });
    }
  }

  render() {
    return (
      <Picky
        selectAllText={this.props.selectAllText}
        placeholder={this.props.placeholder}
        options={this.props.options}
        value={this.state.arrayValue}
        onChange={this.selectMultipleOption}
        valueKey={this.props.valueKey ? this.props.valueKey : "id"}
        labelKey={this.props.labelKey ? this.props.labelKey : "name"}
        multiple
        includeSelectAll={this.props.includeSelectAll}
        includeFilter={this.props.includeFilter ?? true}
        filterPlaceholder={this.props.filterPlaceholder || "Search..."}
        manySelectedPlaceholder={this.props.manySelectedPlaceholder || "%s selected"}
        allSelectedPlaceholder={this.props.allSelectedPlaceholder || "%s selected"}
        dropdownHeight={this.props.height || 500}
        numberDisplayed={this.props.numberDisplayed}
        enableOnly={this.props.enableOnly}
        enableOnlyText={this.props.enableOnlyText}
        className={this.props.enableOnly && "withOnly"}
      />
    );
  }
}

multiSelectDropdown.propTypes = {
  selectAllText: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  selectAll: PropTypes.bool,
  filterType: PropTypes.string,
  updateRegions: PropTypes.func,
  updateSites: PropTypes.func,
  updateLocations: PropTypes.func,
  updateFilters: PropTypes.func,
  enableOnly: PropTypes.bool,
  enableOnlyText: PropTypes.string,
  numberDisplayed: PropTypes.number,
  defaultSelected: PropTypes.bool,
  defaultSelectedNumber: PropTypes.number,
  maxSelect: PropTypes.number,
  includeSelectAll: PropTypes.bool,
  enableMax: PropTypes.bool,
  maxSelected: PropTypes.func,
  selectedFilters: PropTypes.any,
  enableDefaultSelected: PropTypes.bool,
  onSelectChange: PropTypes.func,
  displayCheckedOnly: PropTypes.bool,
  haveOnSelectChange: PropTypes.bool,
  singlePicker: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  updateFilterLevel: PropTypes.any,
  avoidSelectIfMaxSelected: PropTypes.bool,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  filterPlaceholder: PropTypes.string,
  manySelectedPlaceholder: PropTypes.string,
  allSelectedPlaceholder: PropTypes.string,
  includeFilter: PropTypes.bool
};

export default multiSelectDropdown;
